export type FormsKeys = 'uplift_standard' | 'phq9' | 'gad7' | 'PCL5';
export type AssessmentKeys = Extract<FormsKeys, 'phq9' | 'gad7' | 'PCL5'>;
export type IntakeFormKeys = 'uplift_standard' | 'couples_intake' | 'psych_intake' | 'family_intake';

export const intakeFormKeys = [
  'uplift_standard',
  'couples_intake',
  'psych_intake',
  'family_intake'
];

export function getAssessmentFormMaxScore(formId?: string, assessmentKeys?: Record<AssessmentKeys, string>) {

  if (formId === assessmentKeys?.gad7) {
    return 21;
  }
  if (formId === assessmentKeys?.PCL5) {
    return 80;
  }
  if (formId === assessmentKeys?.phq9) {
    return 27;
  }
  return null;

}

export const isIntakeForm = (key: string) => intakeFormKeys.includes(key);
